// -----------------------------------------------------------------------------
// スナックバー アクション
// -----------------------------------------------------------------------------
import types from './types';

/**
 * メッセージ追加
 *
 * @param {SnackMessage} message - メッセージオブジェクト
 * @return {Object} アクションオブジェクト
 */
export const add = (message) => {
  return {
    type: types.ADD,
    message,
  };
};

/**
 * メッセージ削除
 *
 * @param {SnackMessage} message - メッセージオブジェクト
 * @return {Object} アクションオブジェクト
 */
export const del = (message) => {
  return {
    type: types.DEL,
    message,
  };
};

/**
 * メッセージクリア
 *
 * - 指定した表示区分以外のメッセージを削除
 *
 * @param {String} category - 表示区分(画面ID)
 * @return {Object} アクションオブジェクト
 */
export const clear = (category) => {
  return {
    type: types.CLR,
    category,
  };
};
